import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../shared/logo.png";
import "./Header.scss";
import Container from "../../shared/ui/Container";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [isMenuOpen]);

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/what-we-do", label: "What We Do" },
    { path: "/how-it-works", label: "How It Works" },
    { path: "/blog", label: "Blog" },
    { path: "/contact", label: "Contact Us" },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <nav className="header__nav" aria-label="Main navigation">
        <Container className="header__container">
          <Link
            to="/"
            className="header__logo-link"
            aria-label="Home - Digital Access Logo"
          >
            <img
              src={logo}
              alt="Digital Access Logo"
              className="header__logo-image"
            />
          </Link>

          {/* Mobile menu button */}
          <button
            className={`header__menu-toggle ${
              isMenuOpen ? "header__menu-toggle--active" : ""
            }`}
            onClick={toggleMenu}
            aria-expanded={isMenuOpen}
            aria-controls="main-menu"
            aria-label="Toggle navigation menu"
          >
            <span className="header__menu-icon"></span>
            <span className="header__menu-icon"></span>
            <span className="header__menu-icon"></span>
          </button>

          {/* Navigation menu */}
          <ul
            id="main-menu"
            className={`header__menu ${isMenuOpen ? "header__menu--open" : ""}`}
          >
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <li key={link.path} role="none">
                  <Link
                    to={link.path}
                    className={`header__link ${
                      isActive ? "header__link--active" : ""
                    }`}
                    onClick={closeMenu}
                    aria-current={isActive ? "page" : undefined}
                  >
                    {link.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </Container>
      </nav>
    </header>
  );
};

export default Header;
